
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './SubjectSelector.css';

function VerbGameSelector() {
  const navigate = useNavigate();
  const { grade, binyan } = useParams();
  const hasThirdPath =
    grade === 'grade10' ||
    (grade === 'grade11' && ['binyan1', 'binyan2', 'binyan3', 'binyan4'].includes(binyan));

  // Restore scroll position when returning from a game
  useEffect(() => {
    const scrollKey = `verbGameSelector_scroll_${grade}_${binyan || 'all'}`;
    const savedScrollPosition = sessionStorage.getItem(scrollKey);
    if (savedScrollPosition) {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedScrollPosition, 10));
      }, 50);
      // Clear after restoring
      sessionStorage.removeItem(scrollKey);
    }
  }, [grade, binyan]);

  const allVerbGames = [
    {
      id: 'binyan1-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 1 עבר',
      color: '#4CAF50',
      grades: ['grade10', 'grade11'],
      order: { grade10: 1, grade11: 1 },
      binyan: 'binyan1'
    },
    {
      id: 'masdar-game',
      name: 'זיהוי מצדרים',
      icon: '🎈',
      description: 'בניין 1 פיצוץ בלוני מצדר',
      color: '#2FA630',
      grades: ['grade10', 'grade11'],
      order: { grade10: 12, grade11: 12 },
      binyan: 'binyan1'
    },
    {
      id: 'verb-analysis-binyan1-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 1 עבר',
      color: '#3F51B5',
      grades: ['grade10', 'grade11'],
      order: { grade10: 2, grade11: 2 },
      binyan: 'binyan1'
    },
    {
      id: 'binyan1-present',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 1 הווה עתיד',
      color: '#FF9800',
      grades: ['grade10', 'grade11'],
      order: { grade10: 3, grade11: 3 },
      binyan: 'binyan1'
    },
    {
      id: 'verb-analysis-binyan1-present',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 1 הווה-עתיד',
      color: '#FF6F00',
      grades: ['grade10', 'grade11'],
      order: { grade10: 4, grade11: 4 },
      binyan: 'binyan1'
    },
    {
      id: 'grammatical-form',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 1 עבר והווה עתיד',
      color: '#FF6F00',
      grades: ['grade10', 'grade11'],
      order: { grade10: 5, grade11: 5 },
      binyan: 'binyan1'
    },
    {
      id: 'binyan1-both-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 1 עבר והווה-עתיד',
      color: '#00ACC1',
      grades: ['grade10', 'grade11'],
      order: { grade10: 5.5, grade11: 5.5 },
      binyan: 'binyan1'
    },
    {
      id: 'grammatical-form-extended',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 1 עם בינוני פועל/פעול',
      color: '#9C27B0',
      grades: ['grade10', 'grade11'],
      order: { grade10: 10, grade11: 10 },
      binyan: 'binyan1'
    },
    {
      id: 'verb-analysis-extended',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 1 עם בינוני פועל/פעול',
      color: '#7B1FA2',
      grades: ['grade10', 'grade11'],
      order: { grade10: 11, grade11: 11 },
      binyan: 'binyan1'
    },
    {
      id: 'grammatical-form-with-masdar',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 1 כולל מצדר',
      color: '#00695C',
      grades: ['grade10', 'grade11'],
      order: { grade10: 12.5, grade11: 12.5 },
      binyan: 'binyan1'
    },
    {
      id: 'verb-analysis-complete',
      name: 'ניתוח פעלים מלא',
      icon: '🔬',
      description: 'בניין 1 כולל כל הצורות הדקדוקיות',
      color: '#1A237E',
      grades: ['grade10', 'grade11'],
      order: { grade10: 13, grade11: 13 },
      binyan: 'binyan1'
    },
    {
      id: 'verb-analysis-binyan1-both',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 1 עבר והווה עתיד',
      color: '#673AB7',
      grades: ['grade10', 'grade11'],
      order: { grade10: 6, grade11: 6 },
      binyan: 'binyan1'
    },
    {
      id: 'binyan1-all-three-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 1 עבר, הווה-עתיד וציווי',
      color: '#E91E63',
      grades: ['grade10', 'grade11'],
      order: { grade10: 8, grade11: 8 },
      binyan: 'binyan1'
    },
    {
      id: 'verb-analysis-binyan1-all-three',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 1 עבר, הווה-עתיד וציווי',
      color: '#C2185B',
      grades: ['grade10', 'grade11'],
      order: { grade10: 8.5, grade11: 8.5 },
      binyan: 'binyan1'
    },
    {
      id: 'participles-binyan1',
      name: 'בינוני בסיבוב',
      icon: '🔄',
      description: 'בניין 1 בינוני פועל/פעול',
      color: '#5EB9C5',
      grades: ['grade10', 'grade11'],
      order: { grade10: 9, grade11: 9 },
      binyan: 'binyan1'
    },
    {
      id: 'imperative-matching-binyan1',
      name: 'צורת הציווי',
      icon: '❗',
      description: 'בניין 1 בציווי',
      color: '#FF6B9D',
      grades: ['grade10', 'grade11'],
      order: { grade10: 7, grade11: 7 },
      binyan: 'binyan1'
    },
    {
      id: 'verb-tense-game',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'עבר, הווה-עתיד וציווי',
      color: '#E91E63',
      grades: ['grade10', 'grade11'],
      order: { grade10: 7.5, grade11: 7.5 },
      binyan: 'binyan1'
    },
    {
      id: 'all-binyans-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'כל הבניינים עבר גזרת שלמים',
      color: '#E91E63',
      grades: ['grade11'],
      order: { grade11: 26 },
      binyan: 'all-binyans'
    },
    {
      id: 'verb-analysis-binyan10-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 10 עבר גזרת השלמים',
      color: '#5D4037',
      grades: ['grade11'],
      order: { grade11: 25 },
      binyan: 'binyan10'
    },
    {
      id: 'verb-analysis-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'עבר - כל הבניינים',
      color: '#9C27B0',
      grades: ['grade11'],
      order: { grade11: 27 },
      binyan: 'all-binyans'
    },
    {
      id: 'binyan2-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 2 עבר',
      color: '#2196F3',
      grades: ['grade11'],
      order: { grade11: 9 },
      binyan: 'binyan2'
    },
    {
      id: 'verb-analysis-binyan2-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 2 עבר',
      color: '#1976D2',
      grades: ['grade11'],
      order: { grade11: 10 },
      binyan: 'binyan2'
    },
    {
      id: 'binyan2-present',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 2 הווה-עתיד',
      color: '#42A5F5',
      grades: ['grade11'],
      order: { grade11: 11 },
      binyan: 'binyan2'
    },
    {
      id: 'verb-analysis-binyan2-present',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 2 הווה-עתיד',
      color: '#1E88E5',
      grades: ['grade11'],
      order: { grade11: 12 },
      binyan: 'binyan2'
    },
    {
      id: 'grammatical-form-binyan2',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 2 עבר והווה-עתיד',
      color: '#1565C0',
      grades: ['grade11'],
      order: { grade11: 12.5 },
      binyan: 'binyan2'
    },
    {
      id: 'binyan2-both-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 2 עבר והווה-עתיד',
      color: '#0D47A1',
      grades: ['grade11'],
      order: { grade11: 13 },
      binyan: 'binyan2'
    },
    {
      id: 'verb-analysis-binyan2-mixed',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 2 עבר והווה-עתיד',
      color: '#1565C0',
      grades: ['grade11'],
      order: { grade11: 13.2 },
      binyan: 'binyan2'
    },
    {
      id: 'binyan2-imperative',
      name: 'צורת הציווי',
      icon: '❗',
      description: 'בניין 2 בציווי',
      color: '#1565C0',
      grades: ['grade11'],
      order: { grade11: 13.5 },
      binyan: 'binyan2'
    },
    {
      id: 'binyan2-all-three-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 2 עבר, הווה-עתיד וציווי',
      color: '#0D47A1',
      grades: ['grade11'],
      order: { grade11: 13.7 },
      binyan: 'binyan2'
    },
    {
      id: 'verb-analysis-binyan2-all-three',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 2 עבר, הווה-עתיד וציווי',
      color: '#0A3880',
      grades: ['grade11'],
      order: { grade11: 13.8 },
      binyan: 'binyan2'
    },
    {
      id: 'grammatical-form-binyan2-all-three',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 2 עבר, הווה-עתיד וציווי',
      color: '#1565C0',
      grades: ['grade11'],
      order: { grade11: 13.6 },
      binyan: 'binyan2'
    },
    {
      id: 'participles-binyan2',
      name: 'בינוני בסיבוב',
      icon: '🔄',
      description: 'בניין 2 בינוני פועל/פעול',
      color: '#26A69A',
      grades: ['grade11'],
      order: { grade11: 13.9 },
      binyan: 'binyan2'
    },
    {
      id: 'grammatical-form-binyan2-extended',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 2 עבר, הווה-עתיד, ציווי ובינוני פועל/פעול',
      color: '#00897B',
      grades: ['grade11'],
      order: { grade11: 14 },
      binyan: 'binyan2'
    },
    {
      id: 'verb-analysis-binyan2-extended',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 2 עם בינוני פועל/פעול',
      color: '#00695C',
      grades: ['grade11'],
      order: { grade11: 15 },
      binyan: 'binyan2'
    },
    {
      id: 'masdar-game-binyan2',
      name: 'זיהוי מצדרים',
      icon: '🎈',
      description: 'בניין 2 פיצוץ בלוני מצדר',
      color: '#004D40',
      grades: ['grade11'],
      order: { grade11: 15.5 },
      binyan: 'binyan2'
    },
    {
      id: 'grammatical-form-binyan2-with-masdar',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 2 עבר, הווה-עתיד, ציווי, בינוני פועל/פעול ומצדר',
      color: '#00695C',
      grades: ['grade11'],
      order: { grade11: 15.6 },
      binyan: 'binyan2'
    },
    {
      id: 'verb-analysis-binyan2-complete',
      name: 'ניתוח פעלים מלא',
      icon: '🔬',
      description: 'בניין 2 כולל כל הצורות הדקדוקיות',
      color: '#004D40',
      grades: ['grade11'],
      order: { grade11: 15.7 },
      binyan: 'binyan2'
    },
    {
      id: 'binyan3-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 3 עבר גזרת השלמים',
      color: '#9C27B0',
      grades: ['grade11'],
      order: { grade11: 11 },
      binyan: 'binyan3'
    },
    {
      id: 'binyan4-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 4 עבר גזרת השלמים',
      color: '#FF5722',
      grades: ['grade11'],
      order: { grade11: 12 },
      binyan: 'binyan4'
    },
    {
      id: 'verb-analysis-binyan3-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 3 עבר גזרת השלמים',
      color: '#7B1FA2',
      grades: ['grade11'],
      order: { grade11: 13 },
      binyan: 'binyan3'
    },
    {
      id: 'binyan3-present',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 3 הווה-עתיד גזרת השלמים',
      color: '#AB47BC',
      grades: ['grade11'],
      order: { grade11: 14 },
      binyan: 'binyan3'
    },
    {
      id: 'verb-analysis-binyan3-present',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 3 הווה-עתיד',
      color: '#8E24AA',
      grades: ['grade11'],
      order: { grade11: 15 },
      binyan: 'binyan3'
    },
    {
      id: 'grammatical-form-binyan3',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 3 עבר והווה-עתיד',
      color: '#6A1B9A',
      grades: ['grade11'],
      order: { grade11: 15.5 },
      binyan: 'binyan3'
    },
    {
      id: 'binyan3-both-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 3 עבר והווה-עתיד',
      color: '#4A148C',
      grades: ['grade11'],
      order: { grade11: 16 },
      binyan: 'binyan3'
    },
    {
      id: 'verb-analysis-binyan3-mixed',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 3 עבר והווה-עתיד',
      color: '#7B1FA2',
      grades: ['grade11'],
      order: { grade11: 16.2 },
      binyan: 'binyan3'
    },
    {
      id: 'participles-binyan3',
      name: 'בינוני בסיבוב',
      icon: '🔄',
      description: 'בניין 3 בינוני פועל/פעול',
      color: '#7CB342',
      grades: ['grade11'],
      order: { grade11: 16.9 },
      binyan: 'binyan3'
    },
    {
      id: 'grammatical-form-binyan3-extended',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 3 עבר, הווה-עתיד, ציווי ובינוני פועל/פעול',
      color: '#558B2F',
      grades: ['grade11'],
      order: { grade11: 17 },
      binyan: 'binyan3'
    },
    {
      id: 'verb-analysis-binyan3-extended',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 3 עם בינוני פועל/פעול',
      color: '#33691E',
      grades: ['grade11'],
      order: { grade11: 18 },
      binyan: 'binyan3'
    },
    {
      id: 'masdar-game-binyan3',
      name: 'זיהוי מצדרים',
      icon: '🎈',
      description: 'בניין 3 פיצוץ בלוני מצדר',
      color: '#00695C',
      grades: ['grade11'],
      order: { grade11: 18.5 },
      binyan: 'binyan3'
    },
    {
      id: 'grammatical-form-binyan3-with-masdar',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 3 עבר, הווה-עתיד, ציווי, בינוני פועל/פעול ומצדר',
      color: '#2E7D32',
      grades: ['grade11'],
      order: { grade11: 18.6 },
      binyan: 'binyan3'
    },
    {
      id: 'verb-analysis-binyan3-complete',
      name: 'ניתוח פעלים מלא',
      icon: '🔬',
      description: 'בניין 3 כולל כל הצורות הדקדוקיות',
      color: '#1B5E20',
      grades: ['grade11'],
      order: { grade11: 18.7 },
      binyan: 'binyan3'
    },
    {
      id: 'binyan3-imperative',
      name: 'צורת הציווי',
      icon: '❗',
      description: 'בניין 3 בציווי',
      color: '#6A1B9A',
      grades: ['grade11'],
      order: { grade11: 16.5 },
      binyan: 'binyan3'
    },
    {
      id: 'binyan3-all-three-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 3 עבר, הווה-עתיד וציווי',
      color: '#4A148C',
      grades: ['grade11'],
      order: { grade11: 16.7 },
      binyan: 'binyan3'
    },
    {
      id: 'verb-analysis-binyan3-all-three',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 3 עבר, הווה-עתיד וציווי',
      color: '#38006B',
      grades: ['grade11'],
      order: { grade11: 16.8 },
      binyan: 'binyan3'
    },
    {
      id: 'grammatical-form-binyan3-all-three',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 3 עבר, הווה-עתיד וציווי',
      color: '#6A1B9A',
      grades: ['grade11'],
      order: { grade11: 16.6 },
      binyan: 'binyan3'
    },
    {
      id: 'binyan5-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 5 עבר גזרת השלמים',
      color: '#00BCD4',
      grades: ['grade11'],
      order: { grade11: 14 },
      binyan: 'binyan5'
    },
    {
      id: 'verb-analysis-binyan4-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 4 עבר גזרת השלמים',
      color: '#E64A19',
      grades: ['grade11'],
      order: { grade11: 15 },
      binyan: 'binyan4'
    },
    {
      id: 'binyan4-present',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 4 הווה-עתיד גזרת השלמים',
      color: '#F4511E',
      grades: ['grade11'],
      order: { grade11: 16 },
      binyan: 'binyan4'
    },
    {
      id: 'verb-analysis-binyan4-present',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 4 הווה-עתיד',
      color: '#D84315',
      grades: ['grade11'],
      order: { grade11: 17 },
      binyan: 'binyan4'
    },
    {
      id: 'grammatical-form-binyan4',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 4 עבר והווה-עתיד',
      color: '#E64A19',
      grades: ['grade11'],
      order: { grade11: 17.5 },
      binyan: 'binyan4'
    },
    {
      id: 'binyan4-both-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 4 עבר והווה-עתיד',
      color: '#BF360C',
      grades: ['grade11'],
      order: { grade11: 18 },
      binyan: 'binyan4'
    },
    {
      id: 'verb-analysis-binyan4-mixed',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 4 עבר והווה-עתיד',
      color: '#BF360C',
      grades: ['grade11'],
      order: { grade11: 18.2 },
      binyan: 'binyan4'
    },
    {
      id: 'binyan4-imperative',
      name: 'צורת הציווי',
      icon: '❗',
      description: 'בניין 4 בציווי',
      color: '#BF360C',
      grades: ['grade11'],
      order: { grade11: 18.5 },
      binyan: 'binyan4'
    },
    {
      id: 'grammatical-form-binyan4-all-three',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 4 עבר, הווה-עתיד וציווי',
      color: '#A1887F',
      grades: ['grade11'],
      order: { grade11: 18.6 },
      binyan: 'binyan4'
    },
    {
      id: 'binyan4-all-three-tenses',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 4 עבר, הווה-עתיד וציווי',
      color: '#A1887F',
      grades: ['grade11'],
      order: { grade11: 18.7 },
      binyan: 'binyan4'
    },
    {
      id: 'verb-analysis-binyan4-all-three',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 4 עבר, הווה-עתיד וציווי',
      color: '#A1887F',
      grades: ['grade11'],
      order: { grade11: 18.8 },
      binyan: 'binyan4'
    },
    {
      id: 'participles-binyan4',
      name: 'בינוני בסיבוב',
      icon: '🔄',
      description: 'בניין 4 בינוני פועל/פעול',
      color: '#795548',
      grades: ['grade11'],
      order: { grade11: 18.9 },
      binyan: 'binyan4'
    },
    {
      id: 'grammatical-form-binyan4-extended',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 4 עבר, הווה-עתיד, ציווי ובינוני פועל/פעול',
      color: '#8D6E63',
      grades: ['grade11'],
      order: { grade11: 19 },
      binyan: 'binyan4'
    },
    {
      id: 'verb-analysis-binyan4-extended',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 4 עם בינוני פועל/פעול',
      color: '#6D4C41',
      grades: ['grade11'],
      order: { grade11: 20 },
      binyan: 'binyan4'
    },
    {
      id: 'masdar-balloon-game-binyan4',
      name: 'זיהוי מצדרים',
      icon: '🎈',
      description: 'בניין 4 פיצוץ בלוני מצדר',
      color: '#5D4037',
      grades: ['grade11'],
      order: { grade11: 20.5 },
      binyan: 'binyan4'
    },
    {
      id: 'grammatical-form-binyan4-with-masdar',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 4 עבר, הווה-עתיד, ציווי, בינוני פועל/פעול ומצדר',
      color: '#5D4037',
      grades: ['grade11'],
      order: { grade11: 20.6 },
      binyan: 'binyan4'
    },
    {
      id: 'verb-analysis-binyan4-complete',
      name: 'ניתוח פעלים מלא',
      icon: '🔬',
      description: 'בניין 4 כולל כל הצורות הדקדוקיות',
      color: '#4E342E',
      grades: ['grade11'],
      order: { grade11: 20.7 },
      binyan: 'binyan4'
    },
    {
      id: 'binyan6-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 6 עבר גזרת השלמים',
      color: '#8BC34A',
      grades: ['grade11'],
      order: { grade11: 16 },
      binyan: 'binyan6'
    },
    {
      id: 'verb-analysis-binyan5-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 5 עבר גזרת השלמים',
      color: '#0097A7',
      grades: ['grade11'],
      order: { grade11: 17 },
      binyan: 'binyan5'
    },
    {
      id: 'binyan5-present',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 5 הווה-עתיד',
      color: '#00ACC1',
      grades: ['grade11'],
      order: { grade11: 17.1 },
      binyan: 'binyan5'
    },
    {
      id: 'verb-analysis-binyan5-present',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 5 הווה-עתיד',
      color: '#00838F',
      grades: ['grade11'],
      order: { grade11: 17.2 },
      binyan: 'binyan5'
    },
    {
      id: 'grammatical-form-binyan5',
      name: 'מהי הצורה הדקדוקית?',
      icon: '⏰',
      description: 'בניין 5 עבר והווה-עתיד',
      color: '#26A69A',
      grades: ['grade11'],
      order: { grade11: 17.3 },
      binyan: 'binyan5'
    },
    {
      id: 'binyan7-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 7 עבר גזרת השלמים',
      color: '#FFC107',
      grades: ['grade11'],
      order: { grade11: 18 },
      binyan: 'binyan7'
    },
    {
      id: 'verb-analysis-binyan6-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 6 עבר גזרת השלמים',
      color: '#689F38',
      grades: ['grade11'],
      order: { grade11: 19 },
      binyan: 'binyan6'
    },
    {
      id: 'binyan8-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 8 עבר גזרת השלמים',
      color: '#607D8B',
      grades: ['grade11'],
      order: { grade11: 20 },
      binyan: 'binyan8'
    },
    {
      id: 'verb-analysis-binyan7-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 7 עבר גזרת השלמים',
      color: '#FFA000',
      grades: ['grade11'],
      order: { grade11: 21 },
      binyan: 'binyan7'
    },
    {
      id: 'binyan10-past',
      name: 'מי עשה את זה?',
      icon: '👀',
      description: 'בניין 10 עבר גזרת השלמים',
      color: '#795548',
      grades: ['grade11'],
      order: { grade11: 22 },
      binyan: 'binyan10'
    },
    {
      id: 'verb-analysis-binyan8-past',
      name: 'ניתוח פעלים',
      icon: '🔬',
      description: 'בניין 8 עבר גזרת השלמים',
      color: '#455A64',
      grades: ['grade11'],
      order: { grade11: 23 },
      binyan: 'binyan8'
    }
  ];

  let verbGames = allVerbGames
    .filter(game => game.grades.includes(grade));
  
  // סינון לפי בניין אם יש פרמטר binyan (כיתה י"א)
  if (binyan) {
    verbGames = verbGames.filter(game => game.binyan === binyan);
  }
  
  verbGames = verbGames.sort((a, b) => (a.order[grade] || 99) - (b.order[grade] || 99));

  const gradeNames = {
    'grade10': 'שכבה י׳',
    'grade11': 'שכבה י״א',
    'grade12': 'שכבה י״ב'
  };

  const handleGameClick = (gameId) => {
    // Save scroll position before navigating to game
    const scrollKey = `verbGameSelector_scroll_${grade}_${binyan || 'all'}`;
    sessionStorage.setItem(scrollKey, window.scrollY.toString());
    navigate(`/grade/${grade}/verbs/${gameId}`, { state: { fromBinyan: binyan } });
  };

  const handleBackToSubjects = () => {
    if (binyan) {
      navigate(`/grade/${grade}/verbs`);
    } else {
      navigate(`/grade/${grade}`);
    }
  };
  
  const binyanNames = {
    'binyan1': 'בניין 1',
    'binyan2': 'בניין 2',
    'binyan3': 'בניין 3',
    'binyan4': 'בניין 4',
    'binyan5': 'בניין 5',
    'binyan6': 'בניין 6',
    'binyan7': 'בניין 7',
    'binyan8': 'בניין 8',
    'binyan10': 'בניין 10',
    'all-binyans': 'כל הבניינים'
  };

  return (
    <div className="subject-selector verb-selector-screen">
      <div className="subject-selector-container">
        <div className="header-with-back">
          <button
            onClick={handleBackToSubjects}
            className="back-to-grade-button"
            style={{ top: '-32px' }}
          >
            {binyan ? 'חזרה לבחירת בניין ↩' : 'חזרה לבחירת נושא לימוד ↩'}
          </button>
          <h2 style={{ paddingTop: '20px' }}>
            {gradeNames[grade]} - {binyan ? binyanNames[binyan] : 'משחקי הפועל'}
          </h2>
        </div>

        <p className="subject-selector-subtitle">בחר את המשחק שברצונך לשחק</p>

        {verbGames.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#555' }}>
            <div style={{ fontSize: '80px', marginBottom: '20px' }}>📚</div>
            <h3 style={{ fontSize: '24px', marginBottom: '15px' }}>טרם נוספו משחקי פועל ל{gradeNames[grade]}</h3>
            <p style={{ fontSize: '18px', color: '#777' }}>משחקי הפועל זמינים כרגע לשכבות י׳ וי״א</p>
          </div>
        ) : (
          <div className={`verb-games-container${hasThirdPath ? ' has-third-path' : ''}`}>
            <div className="paths-wrapper">
              <div className="path-container">
                {/* מסלול אופקי למחשב */}
                <svg className="path-svg path-desktop" viewBox="0 0 1400 900" preserveAspectRatio="none">
                  <path
                    d="M 175 75 Q 250 90, 425 175 T 675 275 T 925 375 Q 950 425, 825 525 T 575 675 T 325 825"
                    fill="none"
                    stroke="rgba(255, 255, 255, 0.3)"
                    strokeWidth="6"
                    strokeDasharray="15,10"
                    strokeLinecap="round"
                  />
                </svg>
                {/* מסלול אנכי למובייל */}
                <svg className="path-svg path-mobile" viewBox="0 0 400 1700" preserveAspectRatio="none">
                  <path
                    d="M 200 50 Q 150 150, 200 250 Q 250 350, 200 450 Q 150 550, 200 650 Q 250 750, 200 850 Q 150 950, 200 1050 Q 250 1150, 200 1250 Q 150 1350, 200 1450 Q 250 1550, 200 1650"
                    fill="none"
                    stroke="rgba(255, 255, 255, 0.3)"
                    strokeWidth="6"
                    strokeDasharray="15,10"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              {(grade === 'grade10' || (grade === 'grade11' && (binyan === 'binyan1' || binyan === 'binyan2' || binyan === 'binyan3' || binyan === 'binyan4'))) && (
                <div className="path-container path-container-second">
                  {/* מסלול אופקי למחשב */}
                  <svg className="path-svg path-desktop" viewBox="0 0 1400 900" preserveAspectRatio="none">
                    <path
                      d="M 175 75 Q 250 90, 425 175 T 675 275 T 925 375 Q 950 425, 825 525 T 575 675 T 325 825"
                      fill="none"
                      stroke="rgba(255, 255, 255, 0.3)"
                      strokeWidth="6"
                      strokeDasharray="15,10"
                      strokeLinecap="round"
                    />
                  </svg>
                  {/* מסלול אנכי למובייל */}
                  <svg className="path-svg path-mobile" viewBox="0 0 400 1700" preserveAspectRatio="none">
                    <path
                      d="M 200 50 Q 150 150, 200 250 Q 250 350, 200 450 Q 150 550, 200 650 Q 250 750, 200 850 Q 150 950, 200 1050 Q 250 1150, 200 1250 Q 150 1350, 200 1450 Q 250 1550, 200 1650"
                      fill="none"
                      stroke="rgba(255, 255, 255, 0.3)"
                      strokeWidth="6"
                      strokeDasharray="15,10"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              )}
              {hasThirdPath && (
                <div className="path-container path-container-third final-path-container">
                  {/* ОСМЕМ АЕФЧЙ МОЗЩБ */}
                  <svg className="path-svg path-desktop" viewBox="0 0 1400 900" preserveAspectRatio="none">
                    <defs>
                      <clipPath id="verb-final-desktop-clip" clipPathUnits="userSpaceOnUse">
                        <polygon points="620,0 1400,0 1400,900 0,900 0,420 620,420" />
                      </clipPath>
                    </defs>
                    <path
                      d="M 175 75 Q 250 90, 425 175 T 675 275 T 925 375 Q 950 425, 825 525 T 575 675 T 325 825"
                      fill="none"
                      stroke="rgba(255, 255, 255, 0.3)"
                      strokeWidth="6"
                      strokeDasharray="15,10"
                      strokeLinecap="round"
                      clipPath="url(#verb-final-desktop-clip)"
                    />
                  </svg>
                  {/* ОСМЕМ АРЛЙ МОЕБЙЙМ */}
                  <svg className="path-svg path-mobile" viewBox="0 0 400 1700" preserveAspectRatio="none">
                    <path
                      d="M 200 50 Q 150 150, 200 250 Q 250 350, 200 450 Q 150 550, 200 650 Q 250 750, 200 850 Q 150 950, 200 1050 Q 250 1150, 200 1250 Q 150 1350, 200 1450 Q 250 1550, 200 1650"
                      fill="none"
                      stroke="rgba(255, 255, 255, 0.3)"
                      strokeWidth="6"
                      strokeDasharray="15,10"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              )}
            </div>
            {verbGames.map((game) => (
              <div
                key={game.id}
                className="verb-game-bubble"
                onClick={() => handleGameClick(game.id)}
              >
                <div className="bubble-circle">
                  <div className="bubble-icon">{game.icon}</div>
                </div>
                <div className="bubble-text">
                  <h3 className="bubble-name">{game.name}</h3>
                  <p className="bubble-description">{game.description}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default VerbGameSelector;
